import { useMutation } from '@apollo/client';
import removeItemFromCartGQL from '../graphql/mutations/public_site/removeItemFromCart.graphql';
import addItemsToCartGQL from '../graphql/mutations/public_site/addItemsToCart.graphql';
import checkoutGQL from '../graphql/mutations/public_site/checkout.graphql';

export const useRemoveItemFromCart = (options) => useMutation(removeItemFromCartGQL, options);
export const useAddItemsToCart = (options) => useMutation(addItemsToCartGQL, options);
export const useCheckout = (options) => useMutation(checkoutGQL, options);
